export const animatedCheckmarkPathVariants = {
  hidden: { pathLength: 0 },
  visible: {
    pathLength: 1,
    transition: {
      duration: 0.6,
    },
  },
};

export const spinnerTransition = {
  repeat: Infinity,
  duration: 1,
  ease: 'linear',
};

export const companyListItemAnimation = {
  hidden: { y: -20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};

export const companyListAnimation = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,

    transition: {
      delayChildren: 0.1,
      staggerChildren: 0.1,
    },
  },
};
